module.exports = {
  siteTitle: "Manuel Soldini",
  siteSubtitle: "Full stack Software Developer",
  siteDescription: `Manuel Soldini's CV`,
  keywords: ['gatsbyjs', 'react', 'curriculum', 'python', 'developer', 'hacker', 'django', 'flask', 'microservices'],
  authorName: 'Manuel Soldini',
  twitterUsername: '__manus__',
  instagramUsername: 'manuelsoldini',
  githubUsername: 'manuelsoldini',
  authorAvatar: '/images/avatar1',
  authorDescription: `Full Stack Software Developer with a wide range of languages experience. <Br>
	Python enthusiast. Dev-Ops venturer. Sys Admin. Free Software Foundation active member, and of course, a Linux Fan.<Br>
    Jack of all trades, trying to master at least one. <Br>
	Highlights: <strong>Python</strong>, Dev-ops, CSS, HTML, Javascript, React `,
  authorMisc: `<strong>Maker / Tinkerer</strong> <Br> Skiing | Traveling | Hacking | Cooking | 3D Printing | Painting | Woodworking | Astronomy `,
  skills: [
    {
      name: 'Python',
      level: 99
    },
    {
      name: 'Django',
      level: 94
    },
    {
      name: 'HTML & CSS',
      level: 71
    },
    {
      name: 'Javascript',
      level: 77
    },
    {
      name: 'AWS',
      level: 80
    },
    {
      name: 'Git',
      level: 96
    }
  ],
  jobs: [
    {
      company: "Venmo / Paypal",
      begin: {
        month: 'jan',
        year: '2021'
      },
      duration: null,
      occupation: "Senior Backend Engineer",
      description: `<strong>Responsibilities:</strong> Backend engineer for Growth / SWAT team.
      		    <BR>
		    Architecture, design and implementation of AWS CDK micro services and integration with legacy Python's (Django) monolith.
		    `,
      techs: "Python 2.x and 3.x, Django, AWS CDK, AWS Lambdas, DynamoDB, SQL, Nginx, Gunicorn, uWSGI, Redis, RabbitMQ, Docker, Kubernetes and more."
    },
    {
      company: "Codementor",
      begin: {
        month: 'may',
        year: '2020'
      },
      duration: null,
      occupation: "Full Stack Mentor",
      description: `<strong>Responsibilities:</strong> Several different projects as freelancer and as Mentor 
                    <BR>
                    <a href="https://www.codementor.io/@msoldini?refer=badge"><img src="https://www.codementor.io/m-badges/msoldini/book-session.svg" alt="Codementor badge"></a>`,
      techs: "Python 2.x and 3.x, Django, Perl, Ruby. SQL, JS, HTML, CSS, Nginx, Gunicorn, uWSGI, Redis, RabbitMQ and more."
    },
    {
      company: "Agilis",
      begin: {
        month: 'mar',
        year: '2018'
      },
      duration: '2 yr',
      occupation: "Full Stack Senior Developer",
      description: "<strong>Responsibilities:</strong> Architecture design, DevOps, Senior software developer.",
      techs: "Python 3.7, Django, DRF, celery, redis, flask, postgresql, pandas, JS, CSS3, HTML5, react.js, gatsby.js, now.js, React native, Java, AWS."
    },
    {
      company: "Byte 'em Up",
      begin: {
        month: 'nov',
        year: '2016'
      },
      duration: '2 yr e 4 mos',
      occupation: "Head of Technology and Fullstack developer",
      description: `<strong>Responsibilities:</strong> Architecture design, DevOps, technology decision, Senior software developer.
                    Client acquisition, prototyping, estimations, billing and technical leader. <BR>
                    Main projects: <strong>Argentina's Ombudsman</strong> and <strong>Fortune 500 Petrol Company</strong>`,
      techs: "Python 3.x & 2.x, Django, DRF, celery, redis, flask, postgresql, docker, JS, CSS3, HTML5, AWS, GCP. "
    },
    {
      company: "Toptal",
      begin: {
        month: 'jul',
        year: '2013'
      },
      duration: null,
      occupation: "Full Stack Software Developer",
      description: `<strong>Responsibilities:</strong> Several different projects as freelancer as part of the Toptal community,
                    mainly as Senior Full Stack Developer and sometimes with DevOps responsibilities. <BR>
                    Most important Projects: <strong>Bayer Cropscience, Backstage, Dashworks</strong> <BR>
                    <a href="https://www.toptal.com/resume/manuel-nicolas-soldini"><svg width="72.5" height="20" viewBox="0 0 116 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M1.444.866h18.092v23.908H1.444z"></path><path d="M1.241.673h5.574v5.572H1.24z"></path></defs><g fill="none" fill-rule="evenodd"><g transform="translate(56.155 6.993)"><path d="M10.36 4.72c1.406 0 2.596.528 3.535 1.57.968 1.007 1.462 2.327 1.457 3.928-.005 1.61-.484 3.055-1.475 4.107-.943 1.008-2.127 1.52-3.533 1.52-1.384 0-2.538-.506-3.527-1.53-.986-1.06-1.464-2.499-1.464-4.116.005-1.598.5-2.92 1.473-3.927.98-1.046 2.134-1.553 3.523-1.553h.012zm6.802-1.264c-1.565-1.713-3.518-2.59-5.81-2.59-2.208 0-4.4 1.543-5.748 3.067l.005-2.85-4.12-.005-.045 23.383v.307l4.142.007.018-7.313c1.25 1.405 3.232 2.23 5.434 2.236 2.425 0 4.463-.866 6.061-2.567 1.61-1.713 2.43-4.13 2.437-6.904.005-2.832-.792-5.11-2.374-6.771z" fill="white"></path></g><path d="M77.79 11.558l-.017 9.868c-.006 2.13.58 3.649 1.73 4.514.716.54 1.627.813 2.708.813.831 0 2.134-.335 2.134-.335l-.368-3.598s-.951.308-1.412-.021c-.44-.314-.654-.986-.654-1.992l.016-9.249 3.835.005.007-3.43-3.837-.007.012-4.928-4.138-.005-.011 4.928-3.472-.005 3.467 3.442zM43.832 2.93H23.43l-.005 4.087h8.155l-.034 19.076v.375l4.312.006-.017-19.45 7.991-.007z" fill="white"></path><path d="M9.094 19.935a.457.457 0 01-.274 0c-.09-.028-.164-.069-.329-.232l-1.805-1.81c-.159-.16-.205-.24-.233-.33a.451.451 0 010-.273c.028-.091.068-.166.233-.33l5.686-5.674c.159-.16.238-.205.33-.228.092-.03.182-.03.273 0 .091.028.165.068.33.233l1.804 1.81c.16.159.205.238.228.33a.451.451 0 010 .273c-.028.09-.068.165-.233.33l-5.686 5.674c-.152.158-.233.2-.324.227zm12.765-6.568L15.72 7.21a6.435 6.435 0 00-.159-.154L8.52 0 5.416 3.09l4.537 4.548L0 17.558l6.14 6.151c.087.085.171.17.25.245l6.995 7.01 3.062-3.05-4.575-4.586 9.987-9.961z" fill="white"></path><path d="M52.1 17.318c-.004 1.68-.5 3.067-1.48 4.125-.972 1.054-2.184 1.588-3.602 1.588-1.387-.005-2.59-.54-3.562-1.604-.95-1.036-1.434-2.43-1.434-4.132 0-1.702.49-3.09 1.445-4.126.973-1.052 2.174-1.587 3.57-1.587 1.41 0 2.622.54 3.595 1.605.98 1.057 1.473 2.446 1.468 4.13m1.304-6.761c-1.69-1.746-3.99-2.709-6.346-2.64-2.385 0-4.484.836-6.243 2.493-1.775 1.668-2.68 3.984-2.686 6.88-.004 2.896.894 5.213 2.665 6.886 1.757 1.662 3.863 2.509 6.248 2.516.09.005.181.005.274.005 2.23 0 4.438-.955 6.064-2.618 1.191-1.222 2.613-3.386 2.618-6.755.007-3.37-1.405-5.537-2.594-6.767M92.376 23.242c-1.49-.005-2.458-.854-2.453-2.157.006-1.355.95-2.146 2.971-2.488l4.137-.698v.04c-.011 3.123-1.917 5.303-4.637 5.303h-.018zm-1.906-8.77c0-1.052.551-3.37 3.602-3.37 1.082 0 1.696.365 2.213.798.5.415.751 1.439.751 2.288v.398l-5.035.784c-3.99.61-6.278 2.755-6.29 5.896-.005 1.629.587 3.023 1.713 4.047 1.11 1.007 2.63 1.543 4.423 1.548 2.26 0 3.956-.813 5.168-2.493.005.712.005 1.429.005 2.094h4.2l.028-12.063c.005-1.97-.638-3.876-1.906-4.923-1.254-1.031-2.892-1.56-5.265-1.566h-.033c-1.81 0-3.728.479-5.02 1.6-1.52 1.313-2.266 3.398-2.266 5.008l3.712-.046zM103.229 3.21l-.04 23.127v.103l3.716.011.04-23.134v-.102z" fill="white"></path><g transform="translate(109.006 20.206)"><path d="M3.436 2.35v.934h.714c.394 0 .592-.154.592-.46 0-.32-.198-.473-.592-.473h-.714zm1.25 2.645l-.745-1.328h-.505v1.328h-.46v-3.05h1.24c.614 0 .976.363.976.867 0 .427-.32.746-.747.834l.758 1.349h-.517zM1.703 3.471a2.3 2.3 0 00.668 1.666c.45.45.999.68 1.658.68.647 0 1.196-.23 1.645-.68.45-.46.68-1.01.68-1.666 0-.66-.23-1.208-.68-1.657a2.21 2.21 0 00-1.645-.692c-.647 0-1.196.231-1.647.692a2.25 2.25 0 00-.679 1.657zm-.462 0c0-.768.264-1.427.813-1.976A2.688 2.688 0 014.017.673c.768 0 1.437.274 1.976.822.548.549.822 1.208.822 1.976 0 .777-.274 1.427-.822 1.963-.549.549-1.208.811-1.976.811s-1.425-.262-1.963-.81A2.664 2.664 0 011.24 3.47z" fill="white"></path></g></g></svg></a>`,
      techs: "Python 2.x and 3.x, Django, Perl. SQL, JS, HTML, CSS, Nginx, Gunicorn, uWSGI, Redis, RabbitMQ and more."
    },
    {
      company: "Tradehelm Inc",
      begin: {
        month: 'dec',
        year: '2012'
      },
      duration: '5 yr',
      occupation: "Software Developer",
      description: `<strong>Textura Co.:</strong> tech leader, time management, code reviews, technology stack decisions, data model design and coding. <br>
                    <strong>Blustor Co.:</strong> Operative system development for an IoT embedded micro computeri for security applications. <Br>
                    <strong>NextTier Education, Inc.:</strong> Architect consultant, code reviews, and development for student's platform.`,
      techs: "Python, Django, DRF, Lettuce, JS, ReportLabs, Redis, Celery, SQLAlchemy, PostgreSQL, OS, IoT, Perl.",
    },
    {
      company: "Teracode",
      begin: {
        month: 'nov',
        year: '2011'
      },
      duration: '1 yr',
      occupation: "Junior Software Developer",
      description: `<strong>GorilaSpot:</strong> Estimations, prototyping, code reviews, architecture decisions, data model design and coding. <Br>
                    <strong>BitSight:</strong> Management of an outsourced team, data model design, software development.`,
      techs: "Python, Django, DRF, Lettuce, JS, Backbone.js, Celery, PyPy, PostgreSQL."
    }
  ],
  social: {
    twitter: "https://twitter.com/__manus__",
    instagram: "https://www.instagram.com/manuelsoldini/",
    linkedin: "https://www.linkedin.com/in/msoldini",
    github: "https://github.com/manuelsoldini",
    email: "manuel.soldini@gmail.com",
    cv: "/pdf/Manuel_Soldini_resume.pdf"
  },
  siteUrl: 'https://msoldini.com.ar/',
  pathPrefix: './',
  siteCover: '/images/cover.jpeg',
  googleAnalyticsId: 'UA-163769535-1',
  background_color: '#282f33', //#ffffff
  theme_color: '#245151', //'#25303B',
  display: 'minimal-ui',
  icon: 'src/assets/gatsby-icon.png',
  headerLinks: [
    {
      label: 'Manuel Soldini',
      url: '/',
    }
  ]
}
